// import { useQuery } from '@tanstack/react-query';
// import { createFileRoute } from '@tanstack/react-router';
// import { MoreHorizontalIcon, TrashIcon, CheckIcon, XIcon, UserPlusIcon } from 'lucide-react';
// import { useState, useEffect } from 'react';
// import { toast } from 'sonner';

import { createFileRoute } from '@tanstack/react-router';

// import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
// import { Badge } from '@/components/ui/badge';
// import { Button } from '@/components/ui/button';
// import {
//   Dialog,
//   DialogTrigger,
//   DialogContent,
//   DialogHeader,
//   DialogFooter,
//   DialogTitle,
//   DialogDescription,
//   DialogClose,
// } from '@/components/ui/dialog';
// import {
//   DropdownMenu,
//   DropdownMenuContent,
//   DropdownMenuItem,
//   DropdownMenuTrigger,
// } from '@/components/ui/dropdown-menu';
// import { Input } from '@/components/ui/input';
// import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
// import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
// import { cn } from '@/lib/utils';
// import {
//   organizationMembersQuery,
//   organizationInvitesQuery,
//   useOrgMutations,
//   useCurrentOrg,
//   organizationMembershipsQuery,
// } from '@/services/org';

export const Route = createFileRoute('/_authed/_layout/$owner/settings/members')({
  component: () => {},
});

// // Mock data for requests - replace with real data when implemented
// const mockRequests = [
//   {
//     id: '4',
//     name: 'John Doe',
//     email: 'john@example.com',
//     avatar: null,
//     initials: 'JD',
//     requestedDate: 'Feb 26, 2025',
//   },
// ];

// function MembersSettingsComponent() {
//   const { owner } = Route.useParams();
//   const [activeTab, setActiveTab] = useState('members');
//   const [searchQuery, setSearchQuery] = useState('');
//   const [openInvite, setOpenInvite] = useState(false);
//   const [inviteEmail, setInviteEmail] = useState('');
//   const [inviteRole, setInviteRole] = useState<'org:admin' | 'org:member'>('org:member');
//   useEffect(() => {
//     if (!openInvite) {
//       setInviteEmail('');
//       setInviteRole('org:member');
//     }
//   }, [openInvite]);

//   // Get current org for installation ID
//   const { currentOrg } = useCurrentOrg();
//   const installationId = currentOrg.id;

//   // Query hooks
//   const { data: memberships = [], isLoading: membershipsLoading } = useQuery(
//     organizationMembershipsQuery(owner, installationId)
//   );
//   const { data: invites = [], isLoading: invitesLoading } = useQuery(organizationInvitesQuery(owner, installationId));

//   // Mutation hooks
//   const { inviteUsersAsync, cancelInviteAsync, updateMemberRoleAsync, removeMemberAsync } = useOrgMutations(
//     owner,
//     installationId
//   );

//   // Filter members and invites based on search
//   const filteredMembers = memberships.filter(
//     (membership) =>
//       membership.member!.firstName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
//       membership.member!.lastName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
//       membership.member!.primaryEmailAddress?.emailAddress.toLowerCase().includes(searchQuery.toLowerCase())
//   );

//   const filteredInvites = invites.filter((invite) =>
//     invite.emailAddress.toLowerCase().includes(searchQuery.toLowerCase())
//   );

//   // Get initials from name or email
//   const getInitials = (name: string, email: string) => {
//     if (name && name.trim()) {
//       return name
//         .split(' ')
//         .map((n) => n[0])
//         .join('')
//         .toUpperCase()
//         .slice(0, 2);
//     }
//     return email.slice(0, 2).toUpperCase();
//   };

//   const handleRoleChange = async (userId: string, newRole: string) => {
//     try {
//       await updateMemberRoleAsync({
//         userId,
//         role: newRole.toLowerCase() as 'org:admin' | 'org:member',
//       });
//       toast.success('Role updated successfully');
//     } catch (error) {
//       toast.error('Failed to update role');
//     }
//   };

//   const handleRemoveMember = async (userId: string) => {
//     try {
//       await removeMemberAsync(userId);
//       toast.success('Member removed successfully');
//     } catch (error) {
//       toast.error('Failed to remove member');
//     }
//   };

//   const handleCancelInvite = async (inviteId: string) => {
//     try {
//       await cancelInviteAsync(inviteId);
//       toast.success('Invitation cancelled');
//     } catch (error) {
//       toast.error('Failed to cancel invitation');
//     }
//   };
//   const handleInvite = async () => {
//     try {
//       await inviteUsersAsync([{ emailAddress: inviteEmail, role: inviteRole }]);
//       toast.success('Invitation sent');
//       setOpenInvite(false);
//     } catch (error) {
//       toast.error('Failed to send invitation');
//     }
//   };

//   return (
//     <div className="size-full">
//       <div className="p-4 md:p-6 lg:p-8 max-w-6xl mx-auto">
//         {/* Header */}
//         <div className="flex items-center justify-between mb-6">
//           <div>
//             <h1 className="text-2xl font-semibold">Team</h1>
//           </div>
//         </div>

//         {/* Tabs */}
//         <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
//           <div className="flex items-center justify-between">
//             <TabsList className="grid w-fit grid-cols-2">
//               <TabsTrigger value="members" className="flex items-center gap-2">
//                 Members
//                 <Badge variant="secondary" className="ml-1 px-2 py-0 h-5">
//                   {memberships.length}
//                 </Badge>
//               </TabsTrigger>
//               <TabsTrigger value="invites" className="flex items-center gap-2">
//                 Invites
//                 <Badge variant="secondary" className="ml-1 px-2 py-0 h-5">
//                   {invites.length}
//                 </Badge>
//               </TabsTrigger>
//               {/* <TabsTrigger value="requests" className="flex items-center gap-2">
//               Requests
//               <Badge variant="secondary" className="ml-1 px-2 py-0 h-5">
//                 {mockRequests.length}
//               </Badge>
//             </TabsTrigger> */}
//             </TabsList>
//             <Dialog open={openInvite} onOpenChange={setOpenInvite}>
//               <DialogTrigger asChild>
//                 <Button className="bg-purple-600 hover:bg-purple-700 text-white">
//                   <UserPlusIcon className="h-4 w-4 mr-2" />
//                   Invite user
//                 </Button>
//               </DialogTrigger>
//               <DialogContent>
//                 <DialogHeader>
//                   <DialogTitle>Invite user</DialogTitle>
//                   <DialogDescription>Invite a user to your organization by email</DialogDescription>
//                 </DialogHeader>
//                 <div className="grid gap-4 py-4">
//                   <Input
//                     type="email"
//                     placeholder="john@example.com"
//                     value={inviteEmail}
//                     onChange={(e) => setInviteEmail(e.target.value)}
//                   />
//                   <Select
//                     value={inviteRole}
//                     onValueChange={(value) => setInviteRole(value as 'org:admin' | 'org:member')}
//                   >
//                     <SelectTrigger className="w-full">
//                       <SelectValue placeholder="Select role" />
//                     </SelectTrigger>
//                     <SelectContent>
//                       <SelectItem value="org:admin">Admin</SelectItem>
//                       <SelectItem value="org:member">Member</SelectItem>
//                     </SelectContent>
//                   </Select>
//                 </div>
//                 <DialogFooter>
//                   <DialogClose asChild>
//                     <Button variant="outline">Cancel</Button>
//                   </DialogClose>
//                   <Button onClick={handleInvite} disabled={!inviteEmail}>
//                     Invite
//                   </Button>
//                 </DialogFooter>
//               </DialogContent>
//             </Dialog>
//           </div>

//           {/* Search */}
//           <div className="mb-6">
//             <Input
//               type="search"
//               placeholder="Search..."
//               value={searchQuery}
//               onChange={(e) => setSearchQuery(e.target.value)}
//               className="max-w-xs"
//             />
//           </div>

//           {/* Table Headers */}
//           <div className="grid grid-cols-2 gap-4 px-4 py-2 text-sm font-medium text-muted-foreground border-b">
//             <div>Member</div>
//             <div className="text-right">{activeTab === 'requests' ? 'Actions' : 'Role'}</div>
//           </div>

//           {/* Members Tab */}
//           <TabsContent value="members" className="mt-0">
//             {membershipsLoading ? (
//               <div className="text-center py-8 text-muted-foreground">Loading members...</div>
//             ) : (
//               <div className="divide-y">
//                 {filteredMembers.map((member) => (
//                   <div key={member.id} className="grid grid-cols-2 gap-4 items-center px-4 py-4">
//                     <div className="flex items-center gap-3">
//                       <Avatar className="h-10 w-10">
//                         <AvatarImage src={member.member!.imageUrl || undefined} />
//                         <AvatarFallback className="bg-purple-600 text-white">
//                           {member.member!.username?.slice(0, 1).toUpperCase()}
//                         </AvatarFallback>
//                       </Avatar>
//                       <div>
//                         <div className="flex items-center gap-2">
//                           <span className="font-medium">{member.member!.username}</span>
//                           {/* {member.isCurrentUser && (
//                             <Badge variant="outline" className="text-xs">
//                               You
//                             </Badge>
//                           )} */}
//                         </div>
//                         <p className="text-sm text-muted-foreground">
//                           {member.member!.primaryEmailAddress?.emailAddress}
//                         </p>
//                       </div>
//                     </div>
//                     <div className="flex items-center justify-end gap-2">
//                       <Select
//                         defaultValue={member.role}
//                         onValueChange={(value) => handleRoleChange(member.member!.id, value)}
//                         // disabled={member.isCurrentUser}
//                       >
//                         <SelectTrigger className="w-32">
//                           <SelectValue />
//                         </SelectTrigger>
//                         <SelectContent>
//                           <SelectItem value="org:admin">Admin</SelectItem>
//                           <SelectItem value="org:member">Member</SelectItem>
//                         </SelectContent>
//                       </Select>
//                       <DropdownMenu>
//                         <DropdownMenuTrigger asChild>
//                           <Button variant="ghost" size="icon">
//                             <MoreHorizontalIcon className="h-4 w-4" />
//                           </Button>
//                         </DropdownMenuTrigger>
//                         <DropdownMenuContent align="end">
//                           <DropdownMenuItem
//                             className="text-destructive"
//                             onClick={() => handleRemoveMember(member.member!.id)}
//                           >
//                             Remove from organization
//                           </DropdownMenuItem>
//                         </DropdownMenuContent>
//                       </DropdownMenu>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             )}
//           </TabsContent>

//           {/* Invites Tab */}
//           <TabsContent value="invites" className="mt-0">
//             {invitesLoading ? (
//               <div className="text-center py-8 text-muted-foreground">Loading invites...</div>
//             ) : (
//               <div className="divide-y">
//                 {filteredInvites.map((invite) => (
//                   <div key={invite.id} className="grid grid-cols-2 gap-4 items-center px-4 py-4">
//                     <div className="flex items-center gap-3">
//                       <Avatar className="h-10 w-10">
//                         <AvatarFallback className="bg-purple-600 text-white">
//                           {invite.emailAddress.slice(0, 2).toUpperCase()}
//                         </AvatarFallback>
//                       </Avatar>
//                       <div>
//                         <p className="font-medium">{invite.emailAddress}</p>
//                         <p className="text-sm text-muted-foreground">
//                           Invited{' '}
//                           {new Date(invite.createdAt).toLocaleDateString('en-US', {
//                             month: 'short',
//                             day: 'numeric',
//                             year: 'numeric',
//                           })}
//                         </p>
//                       </div>
//                     </div>
//                     <div className="flex items-center justify-end gap-2">
//                       <Select defaultValue={invite.role} disabled>
//                         <SelectTrigger className="w-32">
//                           <SelectValue />
//                         </SelectTrigger>
//                         <SelectContent>
//                           <SelectItem value="org:admin">Admin</SelectItem>
//                           <SelectItem value="org:member">Member</SelectItem>
//                         </SelectContent>
//                       </Select>
//                       <Button variant="ghost" size="icon" onClick={() => handleCancelInvite(invite.id)}>
//                         <TrashIcon className="h-4 w-4 text-destructive" />
//                       </Button>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             )}
//           </TabsContent>

//           {/* Requests Tab */}
//           <TabsContent value="requests" className="mt-0">
//             <div className="divide-y">
//               {mockRequests.map((request) => (
//                 <div key={request.id} className="grid grid-cols-2 gap-4 items-center px-4 py-4">
//                   <div className="flex items-center gap-3">
//                     <Avatar className="h-10 w-10">
//                       <AvatarImage src={request.avatar || undefined} />
//                       <AvatarFallback className="bg-purple-600 text-white">{request.initials}</AvatarFallback>
//                     </Avatar>
//                     <div>
//                       <p className="font-medium">{request.name}</p>
//                       <p className="text-sm text-muted-foreground">{request.email}</p>
//                     </div>
//                   </div>
//                   <div className="flex items-center justify-end gap-2">
//                     <Button
//                       variant="outline"
//                       size="sm"
//                       onClick={() => {
//                         // TODO: Implement reject request
//                       }}
//                     >
//                       <XIcon className="h-4 w-4" />
//                     </Button>
//                     <Button
//                       variant="default"
//                       size="sm"
//                       className="bg-green-600 hover:bg-green-700"
//                       onClick={() => {
//                         // TODO: Implement accept request
//                       }}
//                     >
//                       <CheckIcon className="h-4 w-4" />
//                     </Button>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </TabsContent>
//         </Tabs>
//       </div>
//     </div>
//   );
// }
